export default function getGroupType(groupUA, {districts, schools, educators, classes}) {
  if (districts[groupUA]) {
    return 'School District'
  } else if (schools[groupUA]) {
    return 'School'
  } else if (educators[groupUA]) {
    return 'Teacher'
  } else if (classes[groupUA]) {
    return 'Class'
  } else {
    return null
  }
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getGroupType.js